module.exports = __webpack_public_path__ + "static/media/scanopro-logo.58ccd23b.png";